import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import { useContext, useMemo } from 'react';
import { StylesContext } from '@rexlabs/element-styles';
export default function useMode() {
  var _useContext = useContext(StylesContext),
      modes = _useContext.modes;

  return useMemo(function () {
    var _context;

    return _filterInstanceProperty(_context = _Object$keys(modes)).call(_context, function (mode) {
      return modes[mode];
    });
  }, [modes]);
}